import { apolloCore } from "lib/apollo/apollo";
import runOnce from "lib/runOnce";
import fetchServerTimeUnixMs from "lib/now/fetchServerTimeUnixMs";

import { ApiParams, getListDiscoverTeamsVariables } from "./listDiscoverTeams";

import {
  ListDiscoverTeamsDocument,
  ListDiscoverTeamsQuery,
  ListDiscoverTeamsQueryVariables,
} from "lib/types/graphql";

export interface ListDiscoverTeamsCacheDataItem {
  variables: ListDiscoverTeamsQueryVariables;
  data: ListDiscoverTeamsQuery;
}

export async function getListDiscoverTeamsToPopulateCache(
  apiParams: Omit<ApiParams, "is_archived">
): Promise<ListDiscoverTeamsCacheDataItem> {
  const variables = getListDiscoverTeamsVariables(apiParams);

  const { data } = await apolloCore.query<
    ListDiscoverTeamsQuery,
    ListDiscoverTeamsQueryVariables
  >({
    query: ListDiscoverTeamsDocument,
    variables,
  });

  return {
    variables,
    data,
  };
}

export function populateListDiscoverTeamsCache(
  cacheData: ListDiscoverTeamsCacheDataItem[]
) {
  cacheData.forEach(({ variables, data }) => {
    apolloCore.writeQuery({
      query: ListDiscoverTeamsDocument,
      variables,
      data,
    });
  });
}

export function evictListDiscoverTeamsCache() {
  apolloCore.cache.evict({ id: "ROOT_QUERY", fieldName: "teams" });
  apolloCore.cache.evict({ id: "ROOT_QUERY", fieldName: "teams_aggregate" });
  apolloCore.cache.gc();
}

export function usePopulateListDiscoverTeamsCache(
  cacheData: ListDiscoverTeamsCacheDataItem[],
  { expiresAt }: { expiresAt: number }
) {
  runOnce("usePopulateListDiscoverTeamsCache", () => {
    populateListDiscoverTeamsCache(cacheData);

    fetchServerTimeUnixMs().then((now: number) => {
      if (now > expiresAt) {
        evictListDiscoverTeamsCache();
      }
    });
  });
}
